module.exports = __webpack_public_path__ + "img/win_icon.aaaaf0fd.svg";